var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filters"},[_c('filters-list',{attrs:{"filters":_vm.filters},on:{"filterChanged":_vm.startFiltering}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }